import { useEffect } from "react";
import "./App.scss";
import TodoList from "./components/TodoList";
import AddTodoForm from "./components/AddTodoForm";
import ProgressBar from "./components/ProgressBar";
import { BiRefresh } from "@react-icons/all-files/bi/BiRefresh";
import { BsToggles } from "@react-icons/all-files/bs/BsToggles";
import { BiArchive } from "@react-icons/all-files/bi/BiArchive";
import { MdDeleteForever } from "@react-icons/all-files/md/MdDeleteForever";
import { AiOutlineCloseCircle } from "@react-icons/all-files/ai/AiOutlineCloseCircle";
import { RiMenuAddFill } from "@react-icons/all-files/ri/RiMenuAddFill";
import { useSelector, useDispatch } from "react-redux";

const LOCAL_STORAGE_KEY_CURRENT_TODOS = "myTaskListApp.todos.current";
const LOCAL_STORAGE_KEY_ARCHIVED_TODOS = "myTaskListApp.todos.archived";

function App() {
    const { currentTodos, archivedTodos } = useSelector(({ todos }) => {
        return {
            currentTodos: todos.current,
            archivedTodos: todos.archived,
        };
    });

    const dispatch = useDispatch();

    const handleSideContainerToggle = () => {
        toggleClassOnElement(
            document.getElementsByClassName("side-container")[0],
            "show"
        );
    };

    const toggleClassOnElement = (element, className) => {
        if (element.classList.contains(className)) {
            element.classList.remove(className);
        } else {
            element.classList.add(className);
        }
    };

    useEffect(() => {
        const storedCurrentTodos = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_KEY_CURRENT_TODOS)
        );
        if (storedCurrentTodos)
            dispatch({ type: "SET_CURRENT", payload: storedCurrentTodos });
        const storedArchivedTodos = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_KEY_ARCHIVED_TODOS)
        );
        if (storedArchivedTodos)
          dispatch({ type: "SET_ARCHIVED", payload: storedArchivedTodos });
    }, [dispatch]);

    useEffect(() => {
        localStorage.setItem(
            LOCAL_STORAGE_KEY_CURRENT_TODOS,
            JSON.stringify(currentTodos)
        );
    }, [currentTodos]);

    useEffect(() => {
        localStorage.setItem(
            LOCAL_STORAGE_KEY_ARCHIVED_TODOS,
            JSON.stringify(archivedTodos)
        );
    }, [archivedTodos]);

    return (
        <div className="App">
            <div className="main-container">
                <div className="todos-container">
                    <div className="todos-header">
                        <div>
                            <span>
                                {
                                    currentTodos.filter((t) => !t.completed)
                                        .length
                                }
                                /{currentTodos.length} tasks left
                            </span>
                            <ProgressBar
                                details={{
                                    width: "100%",
                                    height: ".5rem",
                                    fill: `${
                                        currentTodos.length < 1
                                            ? "100"
                                            : (currentTodos.filter(
                                                  (t) => t.completed
                                              ).length /
                                                  currentTodos.length) *
                                              100
                                    }%`,
                                    outerClassName: "progress-bar-outer",
                                    innerClassName: "progress-bar-inner",
                                }}
                            />
                        </div>
                        <h1 className="title-myTodoList">My Task List</h1>
                    </div>
                    <TodoList
                        todosArr={currentTodos}
                        component="div"
                        componentClassName="current-todos"
                    />
                    <div className="toggle-side-view-container open">
                        <button
                            className="btn-type-1"
                            onClick={() => {
                                toggleClassOnElement(
                                    document.getElementsByClassName(
                                        "side-container"
                                    )[0],
                                    "show"
                                );
                            }}
                            title="add a new item/view archived tasks"
                        >
                            <RiMenuAddFill />
                            Menu
                        </button>
                    </div>
                    <div className="quick-controls-container">
                        <button
                            onClick={() => dispatch({ type: "REFRESH_TODOS" })}
                            className="btn-type-1"
                            title="Put uncompleted and due tasks at the top"
                        >
                            <BiRefresh />
                            Refresh
                        </button>
                        <button
                            onClick={() =>
                                dispatch({ type: "TOGGLE_ALL_COMPLETED" })
                            }
                            className="btn-type-1"
                            title="Mark as as completed or uncompleted"
                        >
                            <BsToggles />
                            Toggle all as completed
                        </button>
                        <button
                            onClick={() =>
                                dispatch({ type: "ARCHIVE_COMPLETED" })
                            }
                            className="btn-type-1"
                            title="Put completed tasks in an archive"
                        >
                            <BiArchive />
                            Archive completed tasks
                        </button>
                    </div>
                </div>
                <div className="side-container">
                    <div className="toggle-side-view-container close">
                        <button
                            className="btn-type-1"
                            onClick={handleSideContainerToggle}
                        >
                            <AiOutlineCloseCircle />
                            Close
                        </button>
                    </div>
                    <div className="controls-container">
                        <AddTodoForm />
                    </div>
                    <div className="cleared-todos-container">
                        <div className="cleared-todos-header">
                            <span>Archived Tasks({archivedTodos.length})</span>
                            <button
                                onClick={() =>
                                    dispatch({ type: "DELETE_ARCHIVED_TODOS" })
                                }
                                className="btn-type-1"
                                title="Delete all tasks in archive"
                            >
                                <MdDeleteForever />
                                Delete all
                            </button>
                        </div>
                        <TodoList
                            todosArr={archivedTodos}
                            component="div"
                            componentClassName="cleared-todos-wrapper"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
